/*
 * agwa-state-badge - the pill every workflow state wears.
 *
 * The fill arrives as `--badge-fill`, an inline reference the component builds to the palette
 * token for its resolved colour and face (state-colour-standard.md). This file therefore names
 * no colour and needs no edit when the palette grows; the node spec beside the registry is
 * what guarantees every referenced token exists. Sizing mirrors sl-badge's pill so replaced
 * call sites do not shift.
 */

.badge {
  display: inline-flex;
  align-items: center;
  background: var(--badge-fill);
  color: var(--agwa-state-badge-text);
  font-size: var(--sl-font-size-x-small);
  font-weight: var(--sl-font-weight-semibold);
  line-height: 1;
  letter-spacing: 0.015em;
  padding: 0.4em 0.85em;
  border-radius: var(--agwa-border-radius-pill);
  white-space: nowrap;
}

/*
 * The UNMAPPED look: a value the registry does not know. Deliberately transparent with a dashed
 * edge and muted theme text - visible, neutral, and unlike every real palette colour, so
 * unclassified data can never wear a colour that claims a meaning (the amber-default defect
 * D-040 records). Uses theme tokens: unmapped never appears in the settings page's pinned
 * previews, because registry entries all carry colours by construction.
 */
.badge.unmapped {
  background: transparent;
  border: 1.5px dashed var(--agwa-border-strong);
  color: var(--agwa-text-muted);
  padding: calc(0.4em - 1.5px) calc(0.85em - 1.5px);
}
